<section class="content-side-menu" *ngIf="screenWidth > 1050;else collapseMenu">
  <mat-tree [dataSource]="menuUser" [treeControl]="treeControl" class="menu-tree">
    <mat-tree-node
      *matTreeNodeDef="let sub_module; "
    >
      <div *ngIf="sub_module.services?.length === 0;else showServices"
        class="text-submodule color-hover-primary"
        [ngClass]="{'color-primary': subModuleSelect === sub_module?.route}"
      >
        {{sub_module.description}}
      </div>

      <ng-template #showServices>
        <div class="dropdown-menu">
          <button
            mat-button
            class="btn-submodule"
            [ngClass]="{
              'color-primary': subModuleSelect === sub_module?.route,
              'text-long': sub_module.description.indexOf(' ') === -1 && sub_module.description.length > 29
            }"
            (click)="redirectSubModule(sub_module)"
            #sub_moduleInfoTooltip="matTooltip"
            [matTooltip]="sub_module.description" matTooltipPosition="below"
            [matTooltipDisabled]="!(sub_module.description.indexOf(' ') === -1 && sub_module.description.length > 29)"
            (mouseleave)="sub_moduleInfoTooltip.hide()"
            >
            {{sub_module.description}}
          </button>
          <div class="menu-services" [ngClass]="{'with-service': !sub_module.notServices}"
          >
            <button *ngFor="let service of sub_module.services"
              mat-button
              #serviceInfoTooltip="matTooltip"
              [ngClass]="{'btn-menu-selected': serviceSelect === service?.route}"
              class="btn-service btn-hover-primary"
              (click)="$event.stopPropagation(); setServiceSelect(sub_module, service)"
              [matTooltip]="service.description" matTooltipPosition="right"
              [matTooltipClass]="'mat-tooltip-not-break'"
              [matTooltipDisabled]="!(service.description.length > 29)"
              (mouseleave)="serviceInfoTooltip.hide()"
              >
                <div class="content-text-service">
                  <span class="text-service">

                    {{service.description}}
                  </span>
                </div>
            </button>
          </div>
        </div>
      </ng-template>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let module; when: hasChild">
      <div class="mat-tree-node parent">
        <button mat-flat-button matTreeNodeToggle
        (click)="openModule(module.subModule)"
        [class]="getCssModuleSelected(module)"
        #moduleInfoTooltip="matTooltip"
        [matTooltip]="module.description"
        matTooltipPosition="right"
        [matTooltipDisabled]="!(module.description.length > 27)"
        (mouseleave)="moduleInfoTooltip.hide()"
        >
          <div class="content-label-button">
            <div class="content-icon-menu">
              <mat-icon class="icon-menu" [svgIcon]="iconModule(module.subModule[0]?.route)" aria-hidden="true"></mat-icon>
              <div class="module-description">
                {{module.description}}
              </div>
            </div>
            <mat-icon class="icon-dropdown" aria-hidden="true">
              {{treeControl.isExpanded(module) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </div>
        </button>
      </div>
      <div [class.menu-tree-invisible]="!treeControl.isExpanded(module)">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
</section>


<ng-template #collapseMenu>
  <div class="side-menu-collapse">
    <div class="content-module" *ngFor="let module of menuUser; let i = index">

      <button
        mat-button
        (click)="openModule(module.subModule)"
        [class]="getCssModuleSelected(module)"
        [matMenuTriggerFor]="subModules"
      >
        <mat-icon class="icon-menu" [svgIcon]="iconModule(module.subModule[0].route)" aria-hidden="true"></mat-icon>
      </button>


      <mat-menu #subModules="matMenu" class="menu-submodules" >

        <div class="content-menu-mobile">

          <div class="tooltip-module">
            <span class="text-tooltip">{{module.description}}</span>
          </div>

          <ng-container *ngFor="let subModule of module.subModule">

            <button *ngIf="subModule.notServices;else withServices"
              mat-button
              class="only-service"
              [ngClass]="{
                'color-primary': subModuleSelect === subModule?.route
              }"
              (click)="redirectSubModule(subModule)"
            >
              <span class="desc">{{subModule.description}}</span>
            </button>

            <ng-template #withServices>
              <button
                mat-menu-item
                [matMenuTriggerFor]="services"
                (menuOpened)="moduleSelectActive = false"
                (menuClosed)="moduleSelectActive = true"
                [ngClass]="{'color-primary': subModuleSelect === subModule?.route && moduleSelectActive}"
              >

                <span class="desc">{{subModule.description}}</span>

                <span class="icon-arrow material-icons" aria-hidden="true">
                  chevron_right
                </span>

                <mat-menu #services="matMenu" class="menu-services">
                  <button *ngFor="let service of subModule.services"
                    mat-menu-item
                    [ngClass]="{'color-primary': serviceSelect === service?.route && moduleSelectActive}"
                    (click)="setServiceSelect(subModule, service)"
                  >
                    <span class="desc">{{service.description}}</span>
                  </button>
                </mat-menu>
              </button>
            </ng-template>

          </ng-container>
        </div>
      </mat-menu>
    </div>
  </div>
</ng-template>
